import { render, staticRenderFns } from "./ShopServiceField.vue?vue&type=template&id=f03e1646"
import script from "./ShopServiceField.vue?vue&type=script&lang=ts"
export * from "./ShopServiceField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports